import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {IconComponent} from '../../elements/icon/icon.component';
import {Icons} from '../../../model/icon';
import {LoginService} from '../../../services/login.service';
import {TokenStorageService} from '../../../services/token.storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-login',
  imports: [
    ReactiveFormsModule,
    IconComponent
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  loginGroup: FormGroup;
  error: string = '';
  constructor(private fb: FormBuilder,
              protected loginService: LoginService,
              protected tokenStorageService: TokenStorageService,
              private router: Router) {
    this.loginGroup  = this.fb.group({
      username: [''],
      password: [''],
    });
  }

  ngOnInit() {
  }


  login() {
    this.loginService.login(this.loginGroup.get('username')?.value, this.loginGroup.get('password')?.value).subscribe({
      next: (loginInfo) => {
        this.tokenStorageService.saveLoginInfo(loginInfo);
        this.loginService.update();
        this.router.navigate(["admin"]).then(() => {});
      },
      error: (error) => {
        this.error = error.status + " " + error.message;
      }
    })
  }

  protected readonly Icons = Icons;
}
